/* Kopstorm V2 test layer — SOOS Atelier (7 Sep 2026)
   SOOS-16 <kop-card-slider>: scroll-snap image slider inside product cards.
   Only activates when <html data-kop-cards> is present (set by Intelligems or the preview setting). */
(function () {
  'use strict';
  var root = document.documentElement;
  var ATTR = 'data-kop-cards';
  var pending = [];

  function hydrate(img) {
    if (img.dataset.srcset) { img.srcset = img.dataset.srcset; delete img.dataset.srcset; }
    if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.querySelectorAll('img[data-src]').forEach(hydrate);
      io.unobserve(e.target);
    });
  }, { rootMargin: '240px 0px' }) : null;

  if (!customElements.get('kop-card-slider')) {
    customElements.define('kop-card-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        if (!root.hasAttribute(ATTR)) { pending.push(this); return; }
        this.init();
      }
      init() {
        if (this.dataset.ready) return;
        this.dataset.ready = '1';
        var self = this;
        var track = this.querySelector('.kop-cs__track');
        var slides = Array.prototype.slice.call(this.querySelectorAll('.kop-cs__slide'));
        var dots = Array.prototype.slice.call(this.querySelectorAll('.kop-cs__dot'));
        var prev = this.querySelector('.kop-cs__arrow--prev');
        var next = this.querySelector('.kop-cs__arrow--next');
        if (!track || slides.length < 2) return;

        if (io) io.observe(this); else this.querySelectorAll('img[data-src]').forEach(hydrate);

        var index = 0, raf = 0;
        function setIndex(i) {
          i = Math.max(0, Math.min(slides.length - 1, i));
          if (i === index) return;
          index = i;
          dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
          slides.forEach(function (s, n) { s.setAttribute('aria-hidden', n === index ? 'false' : 'true'); });
          if (prev) prev.hidden = index === 0;
          if (next) next.hidden = index === slides.length - 1;
        }
        function onScroll() {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = 0;
            var w = track.clientWidth || 1;
            setIndex(Math.round(track.scrollLeft / w));
          });
        }
        function go(delta) {
          // make sure the target slide is loaded before it slides in
          self.querySelectorAll('img[data-src]').forEach(hydrate);
          var w = track.clientWidth || 1;
          track.scrollTo({ left: (index + delta) * w, behavior: 'smooth' });
        }
        track.addEventListener('scroll', onScroll, { passive: true });
        track.addEventListener('touchstart', function () { self.querySelectorAll('img[data-src]').forEach(hydrate); }, { passive: true, once: true });
        this.addEventListener('mouseenter', function () { self.querySelectorAll('img[data-src]').forEach(hydrate); }, { once: true });
        [prev, next].forEach(function (btn, n) {
          if (!btn) return;
          btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(n === 0 ? -1 : 1); });
        });
        if (prev) prev.hidden = true;
      }
    });
  }

  function flush() {
    if (!root.hasAttribute(ATTR)) return;
    var list = pending.splice(0);
    list.forEach(function (el) { if (el.isConnected) el.init(); });
    document.querySelectorAll('kop-card-slider:not([data-ready])').forEach(function (el) { el.init(); });
  }
  // Intelligems normally sets the attribute before the body parses; this covers a late set as well.
  if ('MutationObserver' in window) {
    new MutationObserver(flush).observe(root, { attributes: true, attributeFilter: [ATTR] });
  }
  document.addEventListener('DOMContentLoaded', flush);
  // Section Rendering / theme editor re-inserts cards: re-run once per section load.
  document.addEventListener('shopify:section:load', flush);
})();

/* Kopstorm V2 · SOOS-21 countdown timer (14 Sep 2026)
   <kop-pdp-timer> counts down to the next local midnight. The element is hidden by
   CSS unless <html data-kop-timer> is present, so the control arm never paints it. */
(function () {
  'use strict';
  if (customElements.get('kop-pdp-timer')) return;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  customElements.define('kop-pdp-timer', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';
      this.clock = this.querySelector('[data-kop-clock]');
      if (!this.clock) return;
      this.tick = this.tick.bind(this);
      this.tick();
      this.timer = setInterval(this.tick, 1000);
    }
    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }
    tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var left = Math.max(0, Math.floor((end - now) / 1000));
      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      var s = left % 60;
      this.clock.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }
  });
})();
